import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  color: ${colors.text['main-900']};

  div {
    display: flex;
    align-items: center;
    gap: 10px;

    svg {
      flex-shrink: 0;
    }
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    line-height: 0;
    color: ${colors.text['sub-500']};
  }
`;

export const Body = styled.div`
  margin-top: 20px;

  p {
    line-height: 1.6;
    color: ${colors.text['sub-500']};
    font-size: 14px;
    margin: 0;
  }
`;

export const ChangeBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: ${colors.bg['weak-100']};
  border-radius: 6px;
  padding: 12px 14px;
  margin-top: 16px;

  svg {
    flex-shrink: 0;
    color: ${colors.text['sub-500']};
  }
`;

export const TypeBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  column-gap: 10px;
  row-gap: 4px;
`;

export const LegendLabel = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: ${colors.text['sub-500']};
  text-transform: uppercase;
  letter-spacing: 0.4px;
  justify-self: start;
`;

export const Chip = styled.span<{ variant: 'current' | 'new' }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 500;
  width: max-content;
  background-color: ${({ variant }) => (variant === 'current' ? colors.bg['soft-200'] : colors.brand.primary.lighter)};
  color: ${({ variant }) => (variant === 'current' ? colors.text['sub-500'] : colors.text['primary-base'])};
`;

export const ChangeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${colors.text['sub-500']};

  strong {
    color: ${colors.text['main-900']};
  }
`;

export const Footer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 20px;

  button {
    flex: 1;
  }

  @media (max-width: 500px) {
    flex-direction: column-reverse;
  }
`;

export const CancelButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.text['sub-500']};
  padding: 12px;
  text-align: center;
`;
